import vehicles from '../../common/adhesion/vehicles.vue'
import * as obj from '../../common/adhesion/objects'
import Sales from '../../../services/sales'
import Auth from '../../../services/auth'
import Account from '../../../services/account'
import C from '../../common/constantes'
import GenericSummary from '../../common/generic-summary.vue'
import successPage from '../../common/adhesion/success.vue'
import errorPage from '../../common/adhesion/error.vue'
import addressComp from "../../common/address.vue"
import messageDialog from "../../../components/message-dialog.vue";
import * as Utils from "../../../utils"
import chooseNewPlan from './choose-new-plan.vue'
import choosePlan from '../../common/adhesion/choose-plan.vue'
import chooseRecharge from '../../common/adhesion/choose-recharge.vue'
import {
  EventBus
} from '../../../event-bus'

const subs = ['Escolha o plano do novo contrato:', '', 'Cadastre os veículos que irão utilizar o plano:', 'Revise os dados e conclua a adesão:', ''];

export default {
  data() {
    return {
      contract: obj.contract(),
      vehicles: [],
      planId: undefined,
      planName: undefined,
      step: 0,
      subtitle: subs,
      msgError: undefined,
      loading: undefined,
      success: false,
      validacaoFraude:undefined,
      code: undefined,
      boletoUrl: undefined,
      changeAddress: false,
      newAddress: Auth.currentUser.address,
      qtdAllowed: C.qtdAllowed,
      guaranteeTax: undefined,
      newAhesionTax: undefined,
      newVehicleTax: undefined,
      showRecharge: true,
      minValue: 200000,
      total: undefined,
      salesOrder: undefined,
      address: undefined,
      promotionCode: undefined,
      shipmentType: undefined,
      salesResponse: undefined,
      rodosol: undefined,
      isMobile: false,
      isRechargeSelected: false,
      coupon: undefined
    };
  },

  computed: {
    user() {
      return Auth.currentUser
    },
    rodosolCheck(){
      return this.$route.params.rodosol
    },
    contractId() {
      return null
    },
    request() {
      let vm = this;
      let request = {
        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
        account: vm.user,
        addresses: {
          address: [
            vm.address
          ]
        },
        contract: vm.contract,
        listVehicle: {
          vehicle: vm.vehicles
        },
        value: this.total,
        shipmentType: this.shipmentType
      };
      return request;
    }
  },

  created() {
    EventBus.$on('chooseNewPlan', this.choosePlan);
    EventBus.$on('cleanErrors', () => {
      this.msgError = undefined;
    });

  },

  mounted: function () {
       if(window.innerWidth <= 769) {
         this.isMobile = true;
      } else {
         this.isMobile = false;

      }
     window.addEventListener('resize', () => window.innerWidth <= 769 ? this.isMobile = true : this.isMobile = false );
    let vm = this;

    this.rodosol=this.rodosolCheck;
  },

  methods: {

       handleValorSelecionado(valor) {

      if (!valor) {
        this.isRechargeSelected = false;
      } else {
        this.isRechargeSelected = true;
      }

    },

    choosePlan(planId, planName) {
      this.planId = planId;
      this.planName = planName;
      this.contract.plan = {
        planId
      };
      this.getPlanInfo().then(r => {
        this.$router.push({
          name: 'new-contract',
          query: {
            planId
          }
        });
        this.nextStep();
      });

    },
    nextStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      switch (this.step) {
        case 0:
          this.step += 1;
          this.contract.plan.name = this.planName;
          break;
        case 1:
          let p;
          let refPlan;
          if (this.planId == 31 || this.planId == 32 || this.planId == 5) {
            refPlan = this.$refs.chooseRecharge;
            p = refPlan.validateAll();
          } else {
            refPlan = this.$refs.choosePlan;
            p = refPlan.validateAll();
          }
          p.then(r => {
            if (refPlan && refPlan.getCoupon) {
              const couponValue = refPlan.getCoupon();
              if (couponValue) {
                this.coupon = couponValue;
              } else {
                this.coupon = undefined;
              }
            }
            this.step += 1;
          }).catch(err => {
            if (err === 'Cupom inválido') {
              this.msgError = 'Cupom inválido. Verifique o código informado.';
            } else if (this.planId == 2 || this.planId == 3) {
              this.msgError = 'Infome um CPF ou CNPJ válido para continuar';
            } else {
              this.msgError = 'Por favor verifique o valor de recarga';
            }
          });
          break;
        case 2:
          if (this.vehicles.length > 0) {
            let value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;

            this.salesOrder = {
              "_interface": "WEBSITE",
              "planId": this.planId,
              "status": null,
              "type": "ADESÃO VEÍCULO ADICIONAL",
              "salesType": "ADHESIOACONTRACTADDITIONAL",
              "taxpayerIdSeller": null,
              "promotionCode": this.promotionCode,
              "price": value,
              "logisticsDistribution": null,
              "bankBillUrl": null,
              "transactionPassageId": null,
              "vehicleId": null,
              "shipment": null,
              "vehicles": this.vehicles,
              "products": [{
                "productId": 4,
                "productName": "ADESÃO VEÍCULO ADICIONAL",
                "valueUnit": this.newVehicleTax,
                "quantity": this.vehicles.length,
                "valueTotal": value
              }],
            };

            if (true) {
              this.salesOrder.products.push({
                "productId": 2,
                "productName": "RECARGA",
                "valueUnit": this.contract.rechargeValue,
                "quantity": 1,
                "valueTotal": this.contract.rechargeValue
              });
              this.salesOrder.products.push({
                "productId": 3,
                "productName": "TAXA DE RECARGA",
                "valueUnit": this.contract.tax,
                "quantity": 1,
                "valueTotal": this.contract.tax
              });

              this.salesOrder.price += this.contract.tax + this.contract.rechargeValue
            }

            this.step += 1;
          } else
            this.msgError = 'Adicione ao menos um veículo para continuar';
          break;
        
      }
    },
    backStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      if (this.changeAddress)
        this.changeAddress = false;
      else {
        if (this.step == 2) {
          this.coupon = undefined;
        }
        this.step -= 1;
      }
    },
    cancelar() {

      messageDialog.show({
        title: 'Cancelar Novo Plano',
        message: 'Deseja cancelar a adesão de um novo plano?',
        type: 'OK-CANCEL-ADHESION'
      }).then(res => {
        if (res == 'OK') {
          this.$router.push({
            name: 'plans'
          });
        }
      });

    },
    getPlanInfo() {
      this.loading = Sales.getPlanById(this.planId)
        .then(resp => {
          this.newAhesionTax = this.newVehicleTax = _.filter(resp.adhesionTax.adhesionTax, (o) => {
            return o.taxId == C.NEW_VEHICLE_TAXID
          })[0].value;

          if (this.planId == 33 || this.planId == 34) {
            this.guaranteeTax = _.filter(resp.adhesionTax.adhesionTax, (o) => {
              return o.taxId == C.GUARANTEE_TAXID
            })[0].value;
            this.showRecharge = false;

          } else {
            this.guaranteeTax = 0;
          }

          this.planName = resp.name;
      });
      return this.loading;
    },

    submitContractAdditional() {
      const value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;

      const req = {
        deliveryAddressId: this.address.addressId,
        value,
        promotionCode: this.promotionCode,
        secureCode: this.user.taxIdNumber.substring(0, 4),
        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
        vehicles: this.vehicles,
        shipmentType: this.shipmentType
      };

      if (this.coupon) {
        req.coupon = this.coupon;
      }
      req.contract = _.cloneDeep(this.contract);

      const url_atual = window.location.href;
      if (url_atual !== "") {
        const regexp = new RegExp(/\S+pdv\S+/i);
        if (regexp.test(url_atual)) {
          req.promotionCode = "GRAALKM29";
          req.logisticsDistribution = "FOB";
        }
      }

      if (Utils.isCaminhoParana(this.planId)) {
        req.promotionCode = "CAMINHOSDOPARANA";
        req.logisticsDistribution = "FOB";
      }

      req.contract.lcFlag = req.contract.lcFlag ? 1 : 0;

      if (req.shipmentType == 3) {
        req.logisticsDistribution = "FOB";
      }

      this.loading = Sales.adhesionContractAdditional(req)
        .catch((err) => {
          const data = err && err.data ? err.data : {};
          const status = data.status || {};
          this.code = status.code;
          this.msgError = status.message || data.message || "Não foi possível concluir a solicitação.";
          this.salesResponse = undefined;
          $("body").stop().animate({ scrollTop: 0 }, "500", "swing");
        });
    },

    goToStep(value) {
      this.code = undefined;
      this.step = value;
    },
    saveAddress() {
      this.$refs.addressMailing.$validator.validateAll().then((success) => {
        this.loading = Account.updateAddress(this.newAddress)
          .then((r) => {
            this.changeAddress = false;
            let user = Auth.currentUser;
            user.address = this.newAddress;
            Auth.currentUser = user;
          })
          .catch((err) => {
            messageDialog.show({
              title: "Erro",
              message: err.data.status.message,
              headerClass: "modal-danger",
            });
          });
      });
    },
    startRequest() {
      this.$refs.GenericSummary.getInfos().then((r) => {
        this.address = r.address;
        this.promotionCode = r.promotionCode;
        this.shipmentType = r.shipmentType;
        this.submitContractAdditional();
      }).catch(() => {});
    },
  },
  beforeDestroy() {

    EventBus.$off("cleanErrors");
  },

  components: {
    vehicles,
    successPage,
    errorPage,
    addressComp,
    chooseNewPlan,
    choosePlan,
    chooseRecharge,
    GenericSummary,
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/contract/new-contract.js